// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export const columns = [
  {
    name: "City",
    accessor: "location_html",
  },
  {
    name: "Avg. days on the market",
    accessor: "days_on_market",
  },
];

export const currencyFormatter = (value: string) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="GBP"
  />
);

// Data hard coded for now. Should come from backend.
export const rows = [
  {
    location_html: "Sheffield",
    days_on_market: 158,
    cost: 144255,
    rental: 854,
    airbnb: 3973.4,
  },
  {
    location_html: "Birmingham",
    days_on_market: 152,
    cost: 182609,
    rental: 851,
    airbnb: 4798,
  },
  {
    location_html: "Liverpool",
    days_on_market: 207,
    cost: 146075,
    rental: 719,
    airbnb: 3707.2,
  },
  {
    location_html: "Manchester",
    days_on_market: 151,
    cost: 184496,
    rental: 979,
    airbnb: 4721.6,
  },
  {
    location_html: "Newcastle",
    days_on_market: 206,
    cost: 156135,
    rental: 847,
    airbnb: 3626.6,
  },
  {
    location_html: "Nottingham",
    days_on_market: 140,
    cost: 182039,
    rental: 883,
    airbnb: 4125.2,
  },
  {
    location_html: "Belfast",
    days_on_market: 200,
    cost: 140145,
    rental: 629,
    airbnb: 3070.6,
  },
  {
    location_html: "Glasgow",
    days_on_market: 148,
    cost: 168589,
    rental: 831,
    airbnb: 2818,
  },
  {
    location_html: "Leeds",
    days_on_market: 139,
    cost: 178114,
    rental: 892,
    airbnb: 2904,
  },
  {
    location_html: "Bristol",
    days_on_market: 87,
    cost: 306884,
    rental: 1122,
    airbnb: 4179.8,
  },
  {
    location_html: "Southampton",
    days_on_market: 115,
    cost: 287399,
    rental: 1068,
    airbnb: 3507.6,
  },
  {
    location_html: "Cardiff",
    days_on_market: 151,
    cost: 219883,
    rental: 924,
    airbnb: 2635.2,
  },
  {
    location_html: "Aberdeen",
    days_on_market: 132,
    cost: 239747,
    rental: 961,
    airbnb: 2890.2,
  },
  {
    location_html: "Edinburgh",
    days_on_market: 130,
    cost: 326439,
    rental: 1250,
    airbnb: 3307.8,
  },
  {
    location_html: (
      <span>
        London
        <sup>6</sup>
      </span>
    ),
    days_on_market: 144,
    cost: 907038.18,
    rental: 2471.14,
    airbnb: 5159.75,
  },
];
